import * as React from 'react';
import { createElement, cloneElement } from 'react';
import { Form, ResponsiveGrid } from '@alifd/next';
const ProForm = (props, ref) => {
    const { children, columns, spacing = [0, 16, 16, 0], emptyContent, dataSource = {}, ...otherProps } = props;
    debugger;
    return (createElement(Form, { ...otherProps, ref: ref, value: dataSource },
        createElement(ResponsiveGrid, { gap: spacing, columns: columns }, children ? (formatFormItems(children, { ...otherProps })) : (createElement("div", { className: "empty-content" }, emptyContent)))));
};
const HhNextForm = React.forwardRef(ProForm);
export default HhNextForm;
export const formatFormItems = (children, props = {}) => {
    const { status, labelAlign, labelCol, wrapperCol, labelTextAlign } = props;
    const _children = children.filter((child) => child && ['function', 'object'].indexOf(typeof child) > -1);
    return React.Children.map(_children, (child) => {
        if (child && ['function', 'object'].indexOf(typeof child) > -1) {
            const childrenProps = {
                labelCol: child.props?.labelCol ?? labelCol,
                labelAlign: child.props?.labelAlign ?? labelAlign,
                wrapperCol: child.props?.wrapperCol ?? wrapperCol,
                labelTextAlign: child.props?.labelTextAlign ?? labelTextAlign,
                status,
            };
            const { formItemProps = {} } = child.props;
            const formItemColumn = formItemProps.columnSpan;
            const columnSpan = formItemColumn ?? 1;
            return createElement(ResponsiveGrid.Cell, { colSpan: columnSpan }, cloneElement(child, {
                formItemProps: Object.assign({}, pickDefined(childrenProps), formItemProps),
            }));
        }
        return child;
    });
};
const pickDefined = (obj = {}) => {
    const newObj = {};
    Object.keys(obj).forEach((i) => {
        if (typeof obj[i] !== 'undefined') {
            newObj[i] = obj[i];
        }
    });
    return newObj;
};
